
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/[path]",
      function () {
        return require("private-next-pages/checkout/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/[path]"])
      });
    }
  